module.exports = __webpack_public_path__ + "static/img/highest_bg.adce155e.png";